import { PhaserUtils } from "../../utils/PhaserUtils"

export enum SummaryVideo {
    SHS = "secondhand.mp4",
    TOBACCO_IS_ADDICTIVE = "addiction.mp4",
    TOBACCO_IS_BAD = "tobacco-is-bad.mp4",
    TOBACCO_ISNT_COOL = "tobacco-isnt-cool.mp4",
}

export enum SummaryImage {
    SHS = "shs.jpg",
    TOBACCO_IS_ADDICTIVE = "tobacco-is-addictive.jpg",
    TOBACCO_IS_BAD = "tobacco-is-bad.jpg",
    TOBACCO_ISNT_COOL = "tobacco-isnt-cool.jpg",
}

export enum Summary6Audio {
    VIDEO_ICONS = "buddy-booster-summary-video-icons.mp3",
}

export const loadAssets = (game: Phaser.Game) => {
    const load = PhaserUtils.makeLoader(game, "summary-6")

    load.autoLoad({videoGenderedEnum: SummaryVideo, imageEnum: SummaryImage, audioGenderedEnum: Summary6Audio})
}

interface Summary {
    video: SummaryVideo
    thumbnail: SummaryImage
    label: string
}

export const summaryData: Array<Summary> = [
    {
        video: SummaryVideo.TOBACCO_IS_BAD,
        thumbnail: SummaryImage.TOBACCO_IS_BAD,
        label: "1. Tobacco is Bad for You",
    },
    {
        video: SummaryVideo.TOBACCO_IS_ADDICTIVE,
        thumbnail: SummaryImage.TOBACCO_IS_ADDICTIVE,
        label: "2. Tobacco is Addictive",
    },
    {
        video: SummaryVideo.SHS,
        thumbnail: SummaryImage.SHS,
        label: "3. Secondhand Smoke",
    },
    {
        video: SummaryVideo.TOBACCO_ISNT_COOL,
        thumbnail: SummaryImage.TOBACCO_ISNT_COOL,
        label: "4. Tobacco isn't Cool",
    },
]